import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function PainPoints() {
  const points = ['Sientes que das todo y no recibes nada a cambio', 'Vives en piloto automático sin conectar con lo que realmente deseas', 'Sabes que mereces más pero no sabes por dónde empezar', 'Te cuesta mantener hábitos y siempre vuelves al mismo lugar', 'Sientes ansiedad y desconexión emocional en tu día a día'];
  return <section className="py-24 bg-white pt-[20px] pb-[20px]" data-id="element-231">
      <div className="max-w-4xl mx-auto px-6 pl-[20px] pr-[20px] space-y-[25px]" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-233">
          <h2 className="text-3xl md:text-4xl font-serif text-burgundy mb-4" data-id="element-234">
            Esto es para ti si...
          </h2>
          <div className="w-24 h-1 bg-rosegold mx-auto rounded-full opacity-50" data-id="element-235"></div>
        </motion.div>

        <div className="space-y-6" data-id="element-236">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-cream rounded-2xl shadow-sm hover:shadow-md transition-shadow pt-[10px] pb-[10px] pl-[10px] pr-[10px]" data-id="element-237">
              <div className="flex-shrink-0 mt-1" data-id="element-238">
                <Heart className="text-rosegold" size={24} fill="#C4956A" fillOpacity={0.2} data-id="element-239" />
              </div>
              <p className="ml-4 text-taupe font-medium text-[14px]" data-id="element-240">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-241">
          <p className="font-serif text-burgundy italic text-[18px]" data-id="element-242">
            "No estás sola. Es momento de volver a ti."
          </p>
        </motion.div>
      </div>
    </section>;
}